import { defineMessages } from 'react-intl';

const topicModerationMessages = defineMessages({
  deletedByUser: { defaultMessage: 'This topic has been removed by the user.', id: 'tRwuRL' },
  deletedByModerator: {
    defaultMessage: 'This topic has been removed by the moderator.',
    id: 'ynh/Vz',
  },
  userVisibilityOnly: {
    defaultMessage: 'This topic is visible only to you.',
    id: 'rEEJzh',
  },
});

const commentModerationMessages = defineMessages({
  isPending: {
    defaultMessage: 'Your message is pending publication.',
    id: 'We3CrV',
  },
  deletedByUser: {
    defaultMessage: 'This message has been removed by the user.',
    id: 'A4T4xK',
  },
  deletedByModerator: {
    defaultMessage: 'This message has been removed by the moderator.',
    id: 'BaD6a4',
  },
  userVisibilityOnly: {
    defaultMessage: 'This message is visible only to you.',
    id: 'gvaioi',
  },
});

const defaultModerationMessages = defineMessages({
  deleted: { defaultMessage: 'Deleted', id: 'KQvWvD' },
});

export const moderationMessages = {
  topic: topicModerationMessages,
  message: commentModerationMessages,
  default: defaultModerationMessages,
};
